import {
  fontSize,
  minBreakpoints,
  responsiveFontSize,
  theme,
} from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing, text, fonts } = theme;

export const searchHeaderWrapper = css`
  text-align: center;
  margin: 0 auto ${pxToRem(spacing.xl)};
  max-width: ${pxToRem(628)};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      margin: 0 auto 0;
    `,
  )};
`;

export const termPrefix = css`
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  ${fontSize(text.BODY.MD)};
  color: var(--neutral-black-70);
  display: block;
`;

export const term = css`
  font-family: ${fonts.PRIMARY_REGULAR.family};
  font-weight: ${fonts.PRIMARY_REGULAR.weight};
  ${responsiveFontSize({
    XXS: text.HEADING.LG,
    L: text.HEADING.XL,
  })};
  display: block;
`;
